let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ZoZ6")).then(() => parcelRequire('1We21'));